<template>
  <div class="ai-order-config">
    <h5 class="title">
      AI下单配置
      <el-switch
        v-model="configStatus"
        active-text="开"
        inactive-text="关"
        @change="handleConfigStatusChange"
      />
    </h5>
    <div class="form-container">
      <el-form ref="formDataRef" :model="formData" :rules="rules" label-width="120px">
        <el-form-item label="模型：" prop="aiModel">
          <el-select
            v-model="formData.aiModel"
            placeholder="请选择模型"
            @change="handleModelChange"
          >
            <el-option-group
              v-for="modelServiceProviderObj in modelList"
              :key="modelServiceProviderObj.modelName"
              :label="modelServiceProviderObj.modelName"
            >
              <el-option
                v-for="modelName in modelServiceProviderObj.modelList"
                :key="modelName"
                :label="modelName"
                :value="modelName"
              />
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="max_tokens：" prop="maxToken">
          <el-input-number
            v-model="formData.maxToken"
            style="width: 212px"
            :controls="false"
            :min="0"
            :step="1"
            step-strictly
            :max="maxToken"
            placeholder="请输入max_tokens"
          />
          <span v-if="maxTokenLen" style="color: #999; margin-left: 10px;">模型最多支持<span style="color: #059E84;">{{ maxTokenLen }}</span>个token</span>
        </el-form-item>
        <el-form-item label="temperature：" prop="temperature">
          <el-input-number
            v-model="formData.temperature"
            style="width: 212px"
            :controls="false"
            :min="0"
            :max="1"
            :step="0.1"
            step-strictly
            placeholder="请输入temperature"
          />
        </el-form-item>
        <el-form-item label="Prompt：" prop="prompt">
          <el-input v-model="formData.prompt" type="textarea" :maxlength="10000" show-word-limit style="width: 70%" :rows="10" placeholder="请输入prompt" />
        </el-form-item>
        <el-form-item label="联网查询：" prop="needWebSearch">
          <el-switch v-model="formData.needWebSearch" active-value="OPEN" inactive-value="CLOSE" />
        </el-form-item>
        <el-form-item label="流式输出：" prop="needStream">
          <el-switch v-model="formData.needStream" active-value="OPEN" inactive-value="CLOSE" />
        </el-form-item>
        <el-form-item label="批量上传文件：" prop="batchUploadFile">
          <el-upload
            :action="`${Servers.OTMS_WEB_PLUS_SERVER}/bfs_oss/upload`"
            :headers="uploadHeader"
            :multiple="true"
            :limit="10"
            :show-file-list="false"
            :data="uploadData"
            :on-success="handleFileSuccess"
            :on-change="handleFileChange"
            :before-upload="beforeFileUpload"
            style="width: 300px"
          >
            <el-button :disabled="fileList.length >= 10" size="small" type="primary">
              点击上传
            </el-button>
            <div slot="tip" class="el-upload__tip">
              单个文件不超过100M，数量不超过10个
            </div>
          </el-upload>
          <div class="file-list">
            <div v-for="item in fileList" :key="item.url" class="file-item">
              <span class="file-name">{{ item.name }}</span>
              <span class="file-action">
                <i class="el-icon-download" @click="handleFileDownload(item)" />
                <i class="el-icon-delete" @click="handleFileRemove(item)" />
              </span>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <fix-boottom class="bottom_bar">
      <template slot="button">
        <el-button
          v-if="configStatus || (!configStatus &&formData.aiModel)"
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit"
        >
          保存并下一步
        </el-button>
        <el-button @click="handleCancel">
          取消
        </el-button>
      </template>
    </fix-boottom>
  </div>
</template>

<script>
import FixBoottom from '@/components/FixBoottom/index.vue';
import { getToken } from '@/utils/auth';
import { localStorageGet } from '@/utils/localStorage';
import downloadUrlFile from '@/utils/downloadUrl';
import { USER } from '@/constant/storage';
import Servers from '../../../../../env/index';
import { getAiModelList, upsertAiConfig, getAiConfigDetail, deleteAiConfigFile } from '../api';

export default {
  name: 'AddAiOrderConfig',
  components: {
    FixBoottom,
  },
  emits: ['finish'],
  props: {
    customersDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      Servers,
      uploadHeader: {
        Authorization: getToken(),
      },
      uploadData: {
        fileExtension: 'png',
      },
      fileList: [],
      configStatus: false,
      submitLoading: false,
      formData: {
        aiModel: '',
        aiModelName: '',
        maxToken: undefined,
        temperature: undefined,
        prompt: '',
        needWebSearch: 'CLOSE',
        needStream: 'OPEN',
      },
      modelList: [],
      rules: {
        aiModel: [{ required: true, message: '请选择模型', trigger: 'blur' }],
        maxToken: [{ required: true, message: '请输入max_tokens', trigger: 'blur' }],
        temperature: [{ required: true, message: '请输入temperature', trigger: 'blur' }],
        prompt: [{ required: true, message: '请输入prompt', trigger: 'blur' }],
      },
      userInfo: localStorageGet(USER),
      editId: '',
      maxToken: 100000,
    };
  },
  computed: {
    maxTokenLen() {
      const modelServiceProviderObj = this.modelList.find((item) => item.modelList.includes(this.formData.aiModel));
      if (modelServiceProviderObj) {
        return modelServiceProviderObj.maxTokenSize;
      }
      return '';
    },
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      this.getAiModelConfig();
      this.getAiConfigDetail();
    },
    async getAiConfigDetail() {
      const { ownerTenantId, customerCode } = this.customersDetail;
      const res = await getAiConfigDetail({
        tenantId: ownerTenantId,
        customerCode,
        configStatusList: ['OPEN', 'CLOSE'],
        list: ['OPEN', 'CLOSE'],
      });
      if (res) {
        const {
          aiModel,
          aiModelName,
          maxToken,
          temperature,
          prompt,
          uploadFileList,
          id,
          configStatus,
          needWebSearch,
          needStream,
        } = res;
        this.configStatus = configStatus === 'OPEN';
        this.formData.aiModel = aiModel;
        this.formData.aiModelName = aiModelName;
        this.formData.maxToken = maxToken;
        this.formData.temperature = temperature;
        this.formData.prompt = prompt;
        this.formData.needWebSearch = needWebSearch;
        this.formData.needStream = needStream;
        this.formData.id = id;
        this.editId = id;
        this.fileList = (uploadFileList || []).map(({ fileName, fileUrl, ...rest }) => ({
          name: fileName,
          url: fileUrl,
          ...rest,
        }));
      }
    },
    async getAiModelConfig() {
      const res = await getAiModelList();
      this.modelList = res || [];
    },
    handleModelChange(model) {
      const modelServiceProviderObj = this.modelList.find((item) => item.modelList.includes(model));
      if (modelServiceProviderObj) {
        this.formData.aiModelName = modelServiceProviderObj.modelName;
        this.maxToken = modelServiceProviderObj.maxTokenSize;
      } else {
        this.formData.aiModelName = '';
        this.maxToken = 100000;
      }
    },
    handleConfigStatusChange() {
      if (!this.configStatus && !this.editId) {
        this.formData.aiModel = '';
        this.formData.aiModelName = '';
        this.formData.maxToken = undefined;
        this.formData.temperature = undefined;
        this.formData.prompt = '';
      }
    },
    handleFileSuccess(res, file) {
      if (res.code !== '2000000000') {
        this.$message.error(res.msg);
        file.status = 'fail';
        return;
      }
      const { name, response } = file;
      const responseData = response?.data?.[0];
      this.fileList.push({ name, url: responseData.url });
    },
    handleFileChange(file, fileList) {
      const failFileIndex = fileList.findIndex((file) => file.status === 'fail');
      if (failFileIndex > -1) {
        fileList.splice(failFileIndex, 1);
      }
    },
    beforeFileUpload(file) {
      const isLt100M = file.size / 1024 / 1024 < 100;
      if (!isLt100M) {
        this.$message.error('单个文件大小不能超过100M');
        return false;
      }
      this.uploadData.fileExtension = file.name.split('.').pop();
      return true;
    },
    async handleFileRemove(file) {
      console.log(file);
      if (file.extraId) {
        try {
          await deleteAiConfigFile({
            extraId: file.extraId,
            id: this.editId,
          });
          this.fileList = this.fileList.filter((item) => item.url !== file.url);
        } catch (error) {
          console.log(error);
        }
      } else {
        this.fileList = this.fileList.filter((item) => item.url !== file.url);
      }
    },
    handleFileDownload(file) {
      downloadUrlFile(file.url, file.name);
    },
    getSubmitData() {
      const { ownerTenantId, ownerTenantName, customerCode, customerName } = this.customersDetail;
      const { userId: operateId, userName: operateName } = this.userInfo;
      return {
        ...this.formData,
        uploadFileList: this.fileList.map(({ name, url, extraId }) => ({
          fileName: name,
          fileUrl: url,
          extraId: extraId || undefined,
        })),
        tenantId: ownerTenantId,
        tenantName: ownerTenantName,
        customerCode,
        customerName,
        operateId,
        operateName,
        configStatus: this.configStatus ? 'OPEN' : 'CLOSE',
      };
    },
    async handleSubmit() {
      await this.$refs.formDataRef?.validate();
      try {
        this.submitLoading = true;
        const submitData = this.getSubmitData();
        await upsertAiConfig(submitData);
        this.$message.success('保存成功');
        this.$emit('finish');
      } finally {
        this.submitLoading = false;
      }
    },
    handleCancel() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.ai-order-config {
  padding: 20px 20px 50px 20px;
  background-color: #fff;
  .title {
    display: flex;
    align-items: center;
    gap: 10px;
    &::before {
      content: '';
      display: block;
      width: 4px;
      height: 16px;
      background-color: #059E84;
    }
  }
  .form-container {
    margin-top: 20px;
    padding-left: 40px;
    ::v-deep .el-form-item__label {
      margin-top: 4px;
    }
  }
}
::v-deep .bottom_bar {
  .align-right {
    text-align: left;
  }
}
.file-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .file-item {
    font-size: 14px;
    background-color: #f5f7fa;
    padding: 0 10px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 250px;
    .file-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .file-action {
      display: flex;
      align-items: center;
      gap: 5px;
      i {
        cursor: pointer;
        font-size: 16px;
        &:hover {
          color: #059E84;
        }
        &.el-icon-delete {
          color: #f56c6c;
        }
      }
    }
  }
}
</style>
